import { render, staticRenderFns } from "./UserLogout.vue?vue&type=template&id=a19cf648&scoped=true"
import script from "./UserLogout.vue?vue&type=script&lang=js"
export * from "./UserLogout.vue?vue&type=script&lang=js"
import style0 from "./UserLogout.vue?vue&type=style&index=0&id=a19cf648&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a19cf648",
  null
  
)

export default component.exports